import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import { loadParticipantAuditEvent } from '../../../store/participantService';
import { camelToTitleCase } from '../../../utils/stringUtils';
import Button from '../../formElements/Button';

import AuditFinancialRequestsManagement from './AuditFinancialRequestsManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditFinancialRequestsModal = ({ label, requestId, isOpen, onClose }) => {
    const dispatch = useDispatch();

    // USE EFFECTS
    useEffect(() => {
        if (requestId && label && isOpen)
            dispatch(loadParticipantAuditEvent('financial-request', requestId, label));
    }, []);

    // RENDER
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            onClick={(e) => e.stopPropagation()}
            className="muiDialogWrapper"
            id="auditModal">
            <div className={modal.modalHeader}>
                <DialogTitle>{camelToTitleCase(label)} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditFinancialRequestsManagement />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditFinancialRequestsModal.propTypes = {
    label: PropTypes.string,
    requestId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
};

export default AuditFinancialRequestsModal;
